import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, vShow as _vShow, withDirectives as _withDirectives, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "q-gutter-y-md structure-search-form" }
const _hoisted_2 = { style: {"padding":"10px 10px 4px"} }
const _hoisted_3 = {
  id: "sketch-iframe",
  ref: "sketch-iframe",
  "data-toolbars": "reporting",
  title: "marvin js editor",
  src: "../sketch/editorws.html",
  style: {"overflow":"hidden","width":"100%","height":"100% min-width: 500px","min-height":"350px","border":"1px solid darkgray"}
}
const _hoisted_4 = { style: {"padding":"10px"} }

import { computed } from 'vue';

interface Props {
  // Marvin Editor表示
  editorFlg: boolean;
  // SDFファイル
  sdfFile: File | undefined;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'StructureSearchForm',
  props: {
    editorFlg: { type: Boolean },
    sdfFile: {}
  },
  emits: ['changeEditorFlg', 'changeSdfFile'],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emit = __emit;

// Marvin Editor表示
const editorFlgComputed = computed({
  get: () => props.editorFlg,
  set: (value) => {
    emit('changeEditorFlg', value);
  },
});

// SDFファイル
const sdfFileComputed = computed({
  get: () => props.sdfFile,
  set: (value) => {
    emit('changeSdfFile', value);
  },
});

return (_ctx: any,_cache: any) => {
  const _component_q_btn_toggle = _resolveComponent("q-btn-toggle")!
  const _component_q_icon = _resolveComponent("q-icon")!
  const _component_q_file = _resolveComponent("q-file")!
  const _component_q_card = _resolveComponent("q-card")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_q_card, { style: {"max-width":"540px","margin-right":"0","margin-left":"auto","border":"1px solid var(--q-whiteBorder)","box-shadow":"none"} }, {
      default: _withCtx(() => [
        _createVNode(_component_q_btn_toggle, {
          modelValue: editorFlgComputed.value,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((editorFlgComputed).value = $event)),
          flat: "",
          dense: "",
          "text-color": "grey-7",
          "toggle-color": "primary",
          "no-caps": "",
          options: [
          { label: '構造式', value: true },
          { label: 'SDFile', value: false },
        ],
          class: "page-toggle",
          style: {"width":"100%"}
        }, null, 8, ["modelValue"]),
        _withDirectives(_createElementVNode("div", _hoisted_2, [
          _createElementVNode("iframe", _hoisted_3, null, 512)
        ], 512), [
          [_vShow, editorFlgComputed.value]
        ]),
        _withDirectives(_createElementVNode("div", _hoisted_4, [
          _createVNode(_component_q_file, {
            modelValue: sdfFileComputed.value,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((sdfFileComputed).value = $event)),
            outlined: "",
            clearable: "",
            accept: ".sdf",
            onClear: _cache[2] || (_cache[2] = ($event: any) => (sdfFileComputed.value = undefined))
          }, {
            prepend: _withCtx(() => [
              _createVNode(_component_q_icon, { name: "attach_file" })
            ]),
            _: 1
          }, 8, ["modelValue"])
        ], 512), [
          [_vShow, !editorFlgComputed.value]
        ])
      ]),
      _: 1
    })
  ]))
}
}

})